import { lazy } from "react";
import Meetings from "../container/Meetings";
import EventTracking from "../container/EventTracking";
import PlatformTable from "../container/Survey/PlatformTable";
import InterviewSurveyTable from "../container/Survey/InterviewSurveyTable.jsx";
import CandidateCSAT from "../container/Survey/CandidateCSAT.jsx";
const RevampDashboard = lazy(
  () =>
    import("../container/Dashboard/components/revampDashboard/RevampDashboard"),
);
const Login = lazy(() => import("../container/login"));
const SubscriptionManage = lazy(
  () => import("../container/EmployerList/SubscriptionManage"),
);
const ResetPassword = lazy(() => import("../container/ResetPassword"));
const EmployerEmailPage = lazy(
  () => import("../container/EmployerList/EmployerEmailPage"),
);
const EmployerEmailPendingPage = lazy(
  () => import("../container/EmployerList/EmployerEmailPendingPage"),
);
const EmployerProfileManagement = lazy(
  () => import("../container/EmployerList/EmployerProfileManagement"),
);
const CompanyProfile = lazy(
  () => import("../container/EmployerList/EmployerProfile/CompanyProfile"),
);
const EmployerDeletedPage = lazy(
  () => import("../container/EmployerList/EmployerDeletedPage"),
);
const ManageSkillSets = lazy(() => import("../container/Positions/Positions"));
const EmailConfiguration = lazy(
  () => import("../container/EmailConfiguration"),
);
const ResellerPage = lazy(
  () => import("../container/EmployerList/ResellerPage"),
);
const EmployerSuspendedPage = lazy(
  () => import("../container/EmployerList/EmployerSuspendedPage"),
);
const SubscribedList = lazy(
  () => import("../container/EmployerList/SubscribedList"),
);
const GlobalPermission = lazy(
  () => import("../container/EmployerList/GlobalPermission/GlobalPermission"),
);
const EmployerSubusers = lazy(
  () => import("../container/EmployerList/EmployerSubusers"),
);
const Roles = lazy(() => import("../container/RolesAndSubusers/Roles"));
const Subusers = lazy(() => import("../container/RolesAndSubusers/Subusers"));
const DeleteSubUsers = lazy(
  () => import("../container/RolesAndSubusers/DeleteSubusers"),
);

const AddSubuser = lazy(
  () => import("../container/RolesAndSubusers/AddSubuser"),
);
const Product = lazy(() => import("../container/ProductsAndPlan/Product"));
const Plan = lazy(() => import("../container/ProductsAndPlan/Plan"));
const Support = lazy(() => import("../container/Support/Support"));
const ContactInquiries = lazy(
  () => import("../container/ContactInquiries/ContactInquiries"),
);
const UsageDashboard = lazy(
  () => import("../container/EmployerList/UsageDashboard"),
);
const CustomPlan = lazy(
  () => import("../container/ProductsAndPlan/CustomPlan"),
);
const AnnouncementList = lazy(
  () => import("../container/Announcement/AnnouncementList"),
);
const Announcement = lazy(
  () => import("../container/Announcement/Announcement"),
);

const PositionsTable = lazy(
  () => import("../container/Careers/PositionsTable"),
);
const InCBotInterviewSearch = lazy(
  () => import("../container/Product/IncBot/Search"),
);
const ManagePositionUnified = lazy(
  () => import("../container/Product/ManagePosition/PositionManage"),
);
const IncBotInterviewManage = lazy(
  () => import("../container/Product/IncBot/ManageInterviews/InterviewManage"),
);
const IncVidInterviewManage = lazy(
  () => import("../container/Product/IncVid/ManageInterviews/InterviewManage"),
);
const IncFeedInterviewManage = lazy(
  () => import("../container/Product/IncFeed/ManageInterviews/InterviewManage"),
);
const IncScreenInterviewManage = lazy(
  () =>
    import("../container/Product/IncScreen/ManageInterviews/InterviewManage"),
);
const NewsArticle = lazy(() => import("../container/NewsArticle"));
const ApiCallLogs = lazy(() => import("../container/ApiCallLogs"));
const MockInterviews = lazy(() => import("../container/MockInterviews"));
const Invoices = lazy(() => import("../container/Invoices"));

const TwoFactorAuthentication = lazy(
  () => import("../container/TwoFactorAuthentication"),
);
const QuestionBanks = lazy(() => import("../container/QuestionBank"));

const FaqPage = lazy(() => import("../container/FaqPage"));
const Blogs = lazy(() => import("../container/Blogs"));
const Notification = lazy(() => import("../container/Notifications"));
const FeedbackReport = lazy(
  () => import("../component/MyInterviewComponents/FeedbackReport"),
);

const CouponCode = lazy(() => import("../container/MockInterviews/CouponCode"));
const MockInterview = lazy(
  () => import("../container/MockInterviews/Interviews"),
);
const Candidates = lazy(() => import("../container/MockInterviews/Candidates"));
const CandidateProfile = lazy(
  () => import("../container/MockInterviews/CandidateProfile"),
);
const SessionCollection = lazy(() => import("../container/SessionCollection"));
const ResumeScoreClients = lazy(
  () => import("../container/ResumeScoreClients/ResumeScoreClients"),
);
// [2026-08-12] ADDED — InC-Proctor's sign-in handoff page. See the route entry below.
const ProctoringLaunch = lazy(
  () => import("../container/Proctoring/ProctoringLaunch"),
);
const ResumeScoreClientsAPIUsage = lazy(
  () => import("../container/ResumeScoreClients/ResumeScoreClientsAPIUsage"),
);
const EmployerAnalytics = lazy(
  () => import("../container/EmployerList/EmployerAnalytics"),
);
// [2026-09-08] ADDED — a logout the InC-Proctor staff console can navigate to. See the route entry
// below and the component's own header for why it is public.
const Logout = lazy(() => import("../container/Logout/Logout"));

const RoutesFile = [
  {
    path: "/login",
    exact: true,
    name: "Login",
    component: Login,
    resource: "Login",
    private: false,
    mainResource: "",
    action: "View",
  },
  // [2026-09-08] ADDED — sign out by navigating, so another app can hand off to it.
  //
  // The InC-Proctor staff console mints its session from an InCruiter one, so clearing only its own
  // session leaves this one live and one click puts the person back in. Its Sign out now sends the
  // browser here, which ends the session that actually matters and lands on /login.
  //
  // `private: false` ON PURPOSE — a logout that requires you to be signed in cannot be linked to
  // safely, because the caller would have to know your state to choose a URL. Shaped exactly like
  // the /login entry above; nothing shared is touched. The component's header carries the rest of
  // the reasoning, including why a stranger's link can only ever log YOU out.
  {
    path: "/logout",
    exact: true,
    name: "Logout",
    component: Logout,
    resource: "Login",
    private: false,
    mainResource: "",
    action: "View",
  },
  {
    path: "/reset-password",
    exact: true,
    name: "ResetPassword",
    resource: "ResetPassword",
    component: ResetPassword,
    private: false,
    mainResource: "",
    action: "View",
  },
  {
    path: "/notification",
    exact: true,
    name: "Notification",
    component: Notification,
    private: true,
    mainResource: "Common Permission",
    resource: "Notification",
    action: "View",
  },
  {
    path: "/incbot/search",
    exact: true,
    name: "InCBotInterviewSearch",
    component: InCBotInterviewSearch,
    mainResource: "incBot",
    resource: "InCBot Search",
    private: true,
    action: "View",
  },
  {
    path: "/positions",
    exact: true,
    name: "ManagePositionUnified",
    component: ManagePositionUnified,
    private: true,
    mainResource: "incBot",
    resource: "positions",
    action: "View",
  },
  {
    path: "/incbot/interviews/",
    exact: true,
    name: "IncBotInterviewManage",
    component: IncBotInterviewManage,
    private: true,
    mainResource: "incBot",
    resource: "interviewManagement",
    action: "View",
  },
  {
    path: "/incvid/interviews/",
    exact: true,
    name: "IncVidInterviewManage",
    component: IncVidInterviewManage,
    private: true,
    mainResource: "incVid",
    resource: "interviewManagement",
    action: "View",
  },
  {
    path: "/incfeed/interviews/",
    exact: true,
    name: "IncFeedInterviewManage",
    component: IncFeedInterviewManage,
    private: true,
    mainResource: "incFeed",
    resource: "interviewManagement",
    action: "View",
  },
  {
    path: "/incscreen/interviews/",
    exact: true,
    name: "IncScreenInterviewManage",
    component: IncScreenInterviewManage,
    private: true,
    mainResource: "incScreen",
    resource: "interviewManagement",
    action: "View",
  },
  {
    path: "/",
    exact: true,
    name: "MainDashboard",
    component: RevampDashboard,
    mainResource: "commonPermission",
    resource: "otherConfigurations",
    subResource: "dashboardVisibility",
    private: true,
  },
  {
    path: "/employer/subscription-manage",
    exact: true,
    name: "SubscriptionManage",
    component: SubscriptionManage,
    mainResource: "commonPermission",
    resource: "clientManagement",
    subResource: "subscribedClients",
    private: true,
    action: "View",
  },
  {
    path: "/employer/email",
    exact: true,
    name: "EmployerEmailPage",
    component: EmployerEmailPage,
    mainResource: "commonPermission",
    resource: "clientManagement",
    subResource: "pendingProfile",
    private: true,
    action: "View",
  },
  {
    path: "/employer/profile-management",
    exact: true,
    name: "EmployerProfileManagement",
    component: EmployerProfileManagement,
    private: true,
    mainResource: "commonPermission",
    resource: "clientManagement",
    subResource: "approvedProfile",
    action: "View",
  },
  {
    path: "/employer/suspended-page",
    exact: true,
    name: "EmployerSuspendedPage",
    component: EmployerSuspendedPage,
    private: true,
    mainResource: "commonPermission",
    resource: "clientManagement",
    subResource: "suspendedClients",
    action: "View",
  },
  {
    path: "/employer/deleted-page",
    exact: true,
    name: "EmployerDeletedPage",
    component: EmployerDeletedPage,
    private: true,
    mainResource: "commonPermission",
    resource: "clientManagement",
    subResource: "deletedClients",
    action: "View",
  },
  {
    path: "/employer/subscriber-list",
    exact: true,
    name: "SubscribedList",
    component: SubscribedList,
    private: true,
    mainResource: "commonPermission",
    resource: "clientManagement",
    subResource: "subscribedClients",
    action: "View",
  },
  {
    path: "/employer/global-permission",
    exact: true,
    name: "GlobalPermission",
    component: GlobalPermission,
    private: true,
    mainResource: "commonPermission",
    resource: "clientManagement",
    subResource: "globalPermission",
    action: "View",
  },
  {
    path: "/employer/subusers",
    exact: true,
    name: "EmployerSubusers",
    component: EmployerSubusers,
    private: true,
    mainResource: "Common Permission",
    resource: "Suspended Clients",
    action: "View",
  },
  {
    path: "/employer/resellers",
    exact: true,
    name: "ResellerPage",
    component: ResellerPage,
    private: true,
    mainResource: "commonPermission",
    resource: "clientManagement",
    subResource: "resellers",
    action: "View",
  },
  {
    path: "/products",
    exact: true,
    name: "Product",
    component: Product,
    private: true,
    mainResource: "commonPermission",
    resource: "manageProductsPlans",
    action: "View",
  },
  {
    path: "/custom-plans",
    exact: true,
    name: "CustomPlan",
    component: CustomPlan,
    private: true,
    mainResource: "Common Permission",
    resource: "Manage Products",
    action: "View",
  },

  {
    path: "/admin-roles",
    exact: true,
    name: "Roles",
    component: Roles,
    private: true,
    mainResource: "commonPermission",
    resource: "otherConfigurations",
    subResource: "rolesSubusers",
    action: "View",
  },
  {
    path: "/admin-subusers",
    exact: true,
    name: "Subusers",
    component: Subusers,
    private: true,
    mainResource: "commonPermission",
    resource: "otherConfigurations",
    subResource: "rolesSubusers",
    action: "View",
  },
  {
    path: "/admin-deleteusers",
    exact: true,
    name: "DeleteSubUsers",
    component: DeleteSubUsers,
    private: true,
    mainResource: "",
    resource: "",
    action: "View",
  },
  {
    path: "/contact",
    exact: true,
    name: "ContactInquiries",
    component: ContactInquiries,
    private: true,
    mainResource: "Common Permission",
    resource: "Contact Inquiries",
    action: "View",
  },
  {
    path: "/contact",
    exact: true,
    name: "ContactInquiries",
    component: ContactInquiries,
    private: true,
    mainResource: "Common Permission",
    resource: "Survey",
    action: "View",
  },
  {
    path: "/announcement-list",
    exact: true,
    name: "AnnouncementList",
    component: AnnouncementList,
    private: true,
    mainResource: "commonPermission",
    resource: "otherConfigurations",
    subResource: "announcements",
    action: "View",
  },
  {
    path: "/support",
    exact: true,
    name: "Support",
    component: Support,
    private: true,
    mainResource: "commonPermission",
    resource: "otherConfigurations",
    subResource: "support",
    action: "View",
  },
  {
    path: "/careers",
    exact: true,
    name: "PositionsTable",
    component: PositionsTable,
    private: true,
    mainResource: "commonPermission",
    resource: "otherConfigurations",
    subResource: "careers",
    action: "View",
  },
  {
    path: "/platform-survey",
    exact: true,
    name: "PlatformTable",
    component: PlatformTable,
    private: true,
    mainResource: "commonPermission",
    resource: "otherConfigurations",
    subResource: "platform",
    action: "View",
  },
  {
    path: "/interview-survey",
    exact: true,
    name: "InterviewSurveyTable",
    component: InterviewSurveyTable,
    private: true,
    mainResource: "commonPermission",
    resource: "otherConfigurations",
    subResource: "interview",
    action: "View",
  },
  {
    path: "/candidate-CSAT",
    exact: true,
    name: "CandidateCSAT",
    component: CandidateCSAT,
    private: true,
    mainResource: "commonPermission",
    resource: "otherConfigurations",
    subResource: "candidate",
    action: "View",
  },

  {
    path: "/question-banks",
    exact: true,
    name: "QuestionBanks",
    component: QuestionBanks,
    private: true,
    mainResource: "Common Permission",
    resource: "Question Bank",
    action: "View",
  },
  {
    path: "/employer-email-pending",
    exact: true,
    name: "EmployerEmailPendingPage",
    component: EmployerEmailPendingPage,
    private: true,
    mainResource: "Common Permission",
    resource: "Pending",
    action: "View",
  },
  {
    path: "/employer-company-profile",
    exact: true,
    name: "CompanyProfile",
    component: CompanyProfile,
    private: true,
    mainResource: "",
    resource: "",
    action: "View",
  },
  {
    path: "/admin-add-subuser",
    exact: true,
    name: "AddSubuser",
    component: AddSubuser,
    private: true,
    mainResource: "Common Permission",
    resource: "Subuser",
    action: "View",
  },
  {
    path: "/products/plans",
    exact: true,
    name: "Plan",
    component: Plan,
    private: true,
    mainResource: "commonPermission",
    resource: "manageProductsPlans",
    action: "View",
  },
  {
    path: "/usage-dashboard",
    exact: true,
    name: "UsageDashboard",
    component: UsageDashboard,
    private: true,
    permission: true,
    mainResource: "",
    resource: "",
    action: "View",
  },
  {
    path: "/announcement",
    exact: true,
    name: "Announcement",
    component: Announcement,
    private: true,
    mainResource: "Common Permission",
    resource: "Announcements",
    action: "View",
  },
  {
    path: "/feedback-report",
    exact: true,
    name: "FeedbackReport",
    component: FeedbackReport,
    private: false,
    resource: "FeedbackReport",
    mainResource: "Common Permission",
    permission: true,
    action: "View",
  },

  {
    path: "/faq",
    exact: true,
    name: "FaqPage",
    component: FaqPage,
    private: true,
    mainResource: "commonPermission",
    resource: "otherConfigurations",
    subResource: "faq",
    action: "View",
  },
  {
    path: "/blogs",
    exact: true,
    name: "Blogs",
    component: Blogs,
    private: true,
    mainResource: "commonPermission",
    resource: "otherConfigurations",
    subResource: "faq",
    action: "View",
  },
  {
    path: "/news-article",
    exact: true,
    name: "NewsArticle",
    component: NewsArticle,
    private: true,
    action: "Page",
    permission: true,
    action: "View",
    redirect: false,
    mainResource: "commonPermission",
    resource: "otherConfigurations",
    subResource: "websiteNews",
  },
  {
    path: "/two-factor-authentication",
    exact: true,
    name: "twoFactorAuthentication",
    component: TwoFactorAuthentication,
    private: true,
    action: "Page",
    permission: true,
    action: "View",
    redirect: false,
    mainResource: "commonPermission",
    resource: "otherConfigurations",
    subResource: "twoFactorSecurity",
  },
  {
    path: "/api-call-Logs",
    exact: true,
    name: "apiCallLogs",
    component: ApiCallLogs,
    private: true,
    action: "Page",
    permission: true,
    action: "View",
    redirect: false,
    mainResource: "commonPermission",
    resource: "otherConfigurations",
    subResource: "apiCallLogs",
  },
  {
    path: "/mock-interviews",
    exact: true,
    name: "mockInterviews",
    component: MockInterviews,
    private: true,
    resource: "",
    action: "Page",
    mainResource: "",
    permission: true,
    redirect: false,
  },
  {
    path: "/invoices",
    exact: true,
    name: "invoices",
    component: Invoices,
    private: true,
    resource: "",
    action: "Page",
    mainResource: "",
    permission: true,
    redirect: false,
  },
  {
    path: "/mock-interview-candidates",
    exact: true,
    name: "mockInterviewsCandidates",
    component: Candidates,
    private: true,
    resource: "",
    action: "Page",
    mainResource: "",
    permission: true,
    redirect: false,
  },
  {
    path: "/candidate-profile",
    exact: true,
    name: "CandidateProfile",
    component: CandidateProfile,
    private: true,
    mainResource: "",
    resource: "",
    action: "View",
  },
  {
    path: "/mock-interview-coupon-code",
    exact: true,
    name: "mockInterviewsCouponCode",
    component: CouponCode,
    private: true,
    resource: "",
    action: "Page",
    mainResource: "",
    permission: true,
    redirect: false,
  },
  {
    path: "/mock-interview-interviews",
    exact: true,
    name: "mockInterviewInterviews",
    component: MockInterview,
    private: true,
    resource: "",
    action: "Page",
    mainResource: "",
    permission: true,
    redirect: false,
  },
  {
    path: "/meetings",
    exact: true,
    name: "Meetings",
    component: Meetings,
    private: true,
    action: "Page",
    permission: true,
    action: "View",
    redirect: false,
    mainResource: "commonPermission",
    resource: "otherConfigurations",
    subResource: "meetings",
  },
  {
    path: "/event-tracking",
    exact: true,
    name: "EventTracking",
    component: EventTracking,
    private: true,
    action: "Page",
    permission: true,
    action: "View",
    redirect: false,
    mainResource: "commonPermission",
    resource: "otherConfigurations",
    subResource: "meetings",
  },
  {
    path: "/session-collection",
    exact: true,
    name: "SessionCollection",
    component: SessionCollection,
    private: true,
    action: "Page",
    permission: true,
    action: "View",
    redirect: false,
    mainResource: "commonPermission",
    resource: "otherConfigurations",
    subResource: "sessionCollection",
  },
  {
    path: "/resumeScoreClients",
    exact: true,
    name: "resumeScoreClients",
    component: ResumeScoreClients,
    private: true,
    resource: "",
    action: "Page",
    mainResource: "",
    permission: true,
    redirect: false,
  },
  {
    path: "/resume-score-clients/:clientId/api-usage",
    exact: true,
    name: "resumeScoreClientsViewAPIUsage",
    component: ResumeScoreClientsAPIUsage,
    private: true,
    resource: "",
    action: "Page",
    mainResource: "",
    permission: true,
    redirect: false,
  },
  // [2026-08-12] ADDED — InC-Proctor. Shaped exactly like the resumeScoreClients entries above:
  // private, but with an empty mainResource so the page itself is reachable by any signed-in
  // operator. Visibility is controlled by the sidebar entry's own permission node
  // (`proctoringClients`, utils/helper.js) rather than duplicated here, which is the same split
  // the Resume Score screens already use.
  // [2026-09-08] CHANGED — the ROUTE is gated too, not just the menu entry.
  //
  // OLD:
  //   resource: "",
  //   mainResource: "",
  //
  // WHY: a hidden menu entry over an open route is not an access control, it is an undiscoverable
  // one. `/proctoring` is a real, shareable URL, so an operator sent the link by a colleague — or
  // one who was granted the node yesterday and still has a tab open — reached the page regardless
  // of any permission. The comment above used to argue the two should agree, and resolved it by
  // ungating the MENU. This resolves it the other way: if an operator does not have the access,
  // they should not get InC-Proctor.
  //
  // SAME NODES, SAME OR, as the sidebar entry in utils/helper.js — deliberately identical, so the
  // menu and the page cannot disagree about who may be here. RouteList/index.jsx passes this whole
  // object to hasAccess as `content` (MainPage.jsx:74), so these fields are all it reads. A refused
  // operator gets <RestrictedAccess /> instead of the page, not a blank screen.
  //
  // ⚠️ WHAT THIS IS AND IS NOT. This controls who sees and uses the SHORTCUT. It is not the thing
  // protecting proctoring data: ProctoringLaunch is a redirect, and the staff console on the other
  // side authenticates operators itself with its own credential (POST /admin/v1/auth/login — see
  // the header comment in container/Proctoring/ProctoringLaunch.jsx). An operator who reaches the
  // console without rights still has to get past that door. Do not read this gate as more than it is.
  {
    path: "/proctoring",
    exact: true,
    name: "proctoring",
    component: ProctoringLaunch,
    private: true,
    resource: "otherConfigurations",
    action: "Page",
    mainResource: "commonPermission",
    subResourcesOr: ["proctoringClients", "resumeScoreClients"],
    permission: true,
    redirect: false,
  },
  {
    path: "/employer/employer-analytics",
    exact: true,
    name: "EmployerAnalytics",
    component: EmployerAnalytics,
    private: true,
    mainResource: "commonPermission",
    resource: "clientManagement",
    subResource: "employerAnalytics",
    action: "View",
  },
  {
    path: "/positions-list",
    exact: true,
    name: "ManageSkillSets",
    component: ManageSkillSets,
    private: true,
    mainResource: "",
    resource: "Manage Skills Sets",
    action: "View",
  },
  {
    path: "/email-configuration",
    exact: true,
    name: "EmailConfiguration",
    component: EmailConfiguration,
    private: true,
    action: "Page",
    permission: true,
    action: "View",
    redirect: false,
    mainResource: "commonPermission",
    resource: "otherConfigurations",
    subResource: "emailConfiguration",
  },
];

export default RoutesFile;
